__turbopack_context__.v({
  "modal": "StoreHours-module-scss-module__iKqQ5q__modal",
  "updateHeader": "StoreHours-module-scss-module__iKqQ5q__updateHeader",
});
